import { Component, Vue, PropSync, Watch } from 'vue-property-decorator';
import { ConfigurationField } from '@/models/configuration/Field';
import { TableDataSet } from '@/models/tableDataset/TableDataSet';
import { TableDataSetSection } from '@/models/tableDataset/TableDataSetSection';
import { ApiIdentifers } from '@/config/index';
import { DataSet } from '@/models/dataset/DataSet';
import { TableProcessItem } from '@/models/tables/TableProcessItem';
import { ExtractionPointEnums } from '@/enums/ExtractionPointEnums';

@Component
export default class ProcessItemComponent extends Vue {
    @PropSync('dataSet', { type: Object }) public syncedDataSet!: DataSet;
    @PropSync('tableDataSet', { type: Object }) public syncedTableDataSet!: TableDataSet;

    public machineOrder?: TableDataSetSection;
    public showItems: boolean = false;
    public allId = ApiIdentifers.machineOrderAll;
    public exPoints: TableProcessItem[] = [];

    // tslint:disable-next-line: no-empty
    public mounted() {
        this.getMachineOrder();
        this.getExPoints();
    }

    @Watch('syncedDataSet', { deep: true })
    public onSyncedDataSetChanged(newValue: TableDataSet) {
        // LoggerService.LogDebug(`TableItemComponent onSyncedTableDataSetChanged: `, newValue);
        this.getMachineOrder();
    }

    public getMachineOrder() {
        if (this.syncedDataSet) {
            if (this.machineOrder === undefined) {
                const order = this.syncedTableDataSet.sections.find((sec) => sec.identifier === ApiIdentifers.machineOrder);
                if (order !== undefined) {
                    this.machineOrder = new TableDataSetSection(order);
                }
            }

            this.machineOrder!.fields.forEach((mo) => {
                mo.valueBool = this.syncedDataSet.sections.some((sec) => sec.identifier === mo.identifier);
            });

            if (this.machineOrder !== undefined && this.machineOrder.fields !== undefined) {
                this.showItems = true;
            } else {
                this.showItems = false;
            }
        }
    }

    public showMarker(index: number, pos: string) {
        let show = false;
        if (this.exPoints[index].show === true) {
            if (pos === 'before') {
                show = this.exPoints[index].before;
            } else if (pos === 'after') {
                show = this.exPoints[index].after;
            }
        }
        return show;
    }

    /**
     * Method to check if an extreation points needs to be shown.
     * For each machine order entry we can set a marker before and after.
     * Depending on the type of extraction point it is set.
     */
    private getExPoints() {
        if (this.machineOrder) {
            this.machineOrder.fields.forEach((field) => {
                const ep = new TableProcessItem();
                ep.identifier = field.identifier;
                this.exPoints.push(ep);
            });
            const samples = this.syncedDataSet.sections.find((sec) => sec.identifier === ApiIdentifers.sample);
            if (samples && samples.fields) {
                samples.fields.forEach((sample) => {
                    if (sample && sample.fields) {
                        const lab = sample.fields.find((field) => field.identifier === ApiIdentifers.sampleLaboratory);
                        if (lab && lab.fields) {
                            const exPoint = lab.fields.find((x) => x.identifier === ApiIdentifers.sampleLaboratoryExtractionPoint);
                            if (exPoint && exPoint.valueNumber != null) {
                                switch (exPoint.valueNumber as ExtractionPointEnums) {
                                    case ExtractionPointEnums.BALE:
                                        this.setExPointMarker(ApiIdentifers.blowRoom, { before: true });
                                        break;
                                    case ExtractionPointEnums.AFTER_BLOW_ROOM:
                                    case ExtractionPointEnums.AFTER_MIXER:
                                        this.setExPointMarker(ApiIdentifers.blowRoom, { after: true });
                                        break;
                                    case ExtractionPointEnums.INPUT_CARD:
                                        this.setExPointMarker(ApiIdentifers.carding, { before: true });
                                        break;
                                    case ExtractionPointEnums.CARD_SLIVER:
                                        this.setExPointMarker(ApiIdentifers.carding, { after: true });
                                        break;
                                    case ExtractionPointEnums.IDF_SLIVER:
                                        this.setExPointMarker(ApiIdentifers.integratedDrawFrame, { after: true });
                                        break;
                                    case ExtractionPointEnums.BREAKER_DF_SLIVER_1:
                                    case ExtractionPointEnums.BREAKER_DF_SLIVER_2:
                                        this.setExPointMarker(ApiIdentifers.breakerDrawing, { after: true });
                                        break;
                                    case ExtractionPointEnums.LAP:
                                        this.setExPointMarker(ApiIdentifers.lapWinding, { after: true });
                                        break;
                                    case ExtractionPointEnums.COMBED_SLIVER:
                                    case ExtractionPointEnums.COMBER_NOIL:
                                        this.setExPointMarker(ApiIdentifers.combing, { after: true });
                                        break;
                                    case ExtractionPointEnums.FINISHER_DF_SLIVER:
                                        this.setExPointMarker(ApiIdentifers.finisherDrawing, { after: true });
                                        break;
                                    case ExtractionPointEnums.FLYER:
                                        this.setExPointMarker(ApiIdentifers.roving, { after: true });
                                        break;
                                    case ExtractionPointEnums.SPINNING_YARN:
                                    case ExtractionPointEnums.WINDING_YARN:
                                        this.setExPointMarker(ApiIdentifers.spinningProcess, { after: true });
                                        break;
                                    default:
                                        break;
                                }
                            }
                        }
                    }
                });
            }
        }
    }

    private setExPointMarker(inIdentifier: string, args: { before?: boolean, after?: boolean }) {
        const point = this.exPoints.find((ep) => ep.identifier === inIdentifier);
        if (point) {
            point.show = true;
            point.before = args && args.before || point.before;
            point.after = args && args.after || point.after;
        }
    }
}
